import { Carousel, Col, Row } from "react-bootstrap";
import FinancingCard from "../VehicleCard/FinancingCard";
import "./FinancingCarousel.scss";

const SLIDES_PER_VIEW = 3;

const groupFinanciaciones = (items, perSlide = SLIDES_PER_VIEW) => {
  if (!items?.length) return [];
  const groups = [];
  for (let i = 0; i < items.length; i += perSlide) {
    groups.push(items.slice(i, i + perSlide));
  }
  return groups;
};

const FinancingCarousel = ({ financiaciones }) => {
  if (!financiaciones?.length) return null;

  const groupedFinanciaciones = groupFinanciaciones(financiaciones);
  const hasMultipleSlides = groupedFinanciaciones.length > 1;
  const isSingleOption = financiaciones.length === 1;

  if (isSingleOption) {
    return (
      <div className="financing-carousel financing-carousel--single">
        <FinancingCard {...financiaciones[0]} />
      </div>
    );
  }

  return (
    <Carousel className="financing-carousel" controls={hasMultipleSlides} indicators={hasMultipleSlides}>
      {groupedFinanciaciones.map((group, idx) => (
        <Carousel.Item key={idx}>
          <Row className="justify-content-center">
            {group.map((f, i) => (
              <Col key={f.id || i} lg={4} md={6} xs={12} className="mb-4 d-flex">
                <FinancingCard {...f} />
              </Col>
            ))}
          </Row>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default FinancingCarousel;
